import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Upload } from "lucide-react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVehicle } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function createData(
  id,
  attachments,
  tyrePosition,
  tyreDotNo,
  tyreSize,
  tyreType,
  tyrePrice,
  kilometerLimit,
  manufacturedBy,
  dateOfManufacturing,
  purchaseDate,
  isActive,
  warrantyPeriod,
  warrantyStartDate,
  warrantyEndDate,
  isInstalled,
  installedDate,
  isSwapped,
  swappedFromVehicleId,
  costToCompany,
  sgstPercentage,
  sgst,
  cgstPercentage,
  cgst,
  totalTaxPercentage,
  totalTax,
  labourCost,
  discountAmount,
  discountPercentage,
  totalCost,
  createdAt,
) {
  return {
    id,
    attachments,
    tyrePosition,
    tyreDotNo,
    tyreSize,
    tyreType,
    tyrePrice,
    kilometerLimit,
    manufacturedBy,
    dateOfManufacturing,
    purchaseDate,
    isActive,
    warrantyPeriod,
    warrantyStartDate,
    warrantyEndDate,
    isInstalled,
    installedDate,
    isSwapped,
    swappedFromVehicleId,
    costToCompany,
    sgstPercentage,
    sgst,
    cgstPercentage,
    cgst,
    totalTaxPercentage,
    totalTax,
    labourCost,
    discountAmount,
    discountPercentage,
    totalCost,
    createdAt,
  };
}

const Tyresdetails = ({ workOrderDetail }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueType;
  delete issueType?.inverted;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issuePriority;
  const tyrePosition = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.tyrePosition;
  delete tyrePosition?.inverted;
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [myIssues, setMyIssuesDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [errors, setErrors] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [tyreDetails, setTyreDetails] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editTyreId, setTyreId] = useState(null);
  const [open, setOpen] = useState(false);
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const validation = [
    Number(workorderStatus?.inverted?.serviceCompleted),
    Number(workorderStatus?.inverted?.enrouteToHub),
    Number(workorderStatus?.inverted?.billingApproved),
    Number(workorderStatus?.inverted?.billingApprovalRequest),
  ].includes(Number(workOrderDetail?.serviceStatus));

  const handleImageOpen = (img) => {
    setPreviewImage(img);
    setPreviewOpen(true);
  };

  const generalInformationofTyre = [
    {
      label: "Tyre Position",
      value: "tyrePosition",
      type: "dropdown",
      disabled: false,
      subCategory:
        tyrePosition &&
        Object.entries(tyrePosition).map(([key, value]) => ({
          value: value, // or whatever property you want
          label: key,
        })),
    },
    {
      label: "Tyre DOT No",
      value: "tyreDotNo",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Tyre Size",
      value: "tyreSize",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Tyre Type",
      value: "tyreType",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "Tubeless", value: "Tubeless" },
        { key: "Tube", value: "Tube" },
      ],
    },
    {
      label: "Tyre Price",
      value: "tyrePrice",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Kilometer Limit",
      value: "kilometerLimit",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Date of Manufacturing",
      value: "dateOfManufacturing",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Manufactured By",
      value: "manufacuturedBy",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty Period",
      value: "warrantyPeriod",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Purchase Date",
      value: "purchaseDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty Start Date",
      value: "startDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty End Date",
      value: "endDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Installed Date",
      value: "installedDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Is Installed",
      value: "isInstalled",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Is Swapped",
      value: "isSwapped",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Swapped Old Vehicle no",
      value: "vehicleNo",
      type: "dropdown",
      disabled: false,
      subCategory:
        vehicles &&
        Object.entries(vehicles).map(([key, item]) => ({
          value: item?.licensePlate + "__" + item?.name, // or whatever property you want
          label: item?.id,
        })),
    },
    // {
    //   label: "Issue Id",
    //   value: "issueId",
    //   type: "dropdown",
    //   disabled: false,
    //   subCategory:
    //     myIssues &&
    //     Object.entries(myIssues).map(([key, item]) => ({
    //       value: item?.code, // or whatever property you want
    //       label: item?.id,
    //     })),
    // },
    // {
    //   label: "Vendor Name",
    //   value: "vendorName",
    //   type: "text",
    //   disabled: false,
    //   subCategory: null,
    // },
    // {
    //   label: "Vendor Contact",
    //   value: "vendorContact",
    //   type: "text",
    //   disabled: false,
    //   subCategory: null,
    // },
    // {
    //   label: "Vendor Address",
    //   value: "vendorAddress",
    //   type: "text",
    //   disabled: false,
    //   subCategory: null,
    // },
    // {
    //   label: "Is Payment Pending",
    //   value: "isPaymentPending",
    //   type: "dropdown",
    //   disabled: false,
    //   subCategory: [
    //     { key: "true", value: "True" },
    //     { key: "false", value: "False" },
    //   ],
    // },
    {
      label: "Cost to Company",
      value: "costToCompany",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "CGST Amount",
      value: "cgst",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "SGST Amount",
      value: "sgst",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Total Tax",
      value: "totalTax",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Labour Cost",
      value: "labourCost",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Total Cost",
      value: "totalCost",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "CGST Percentage",
      value: "cgstPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "SGST Percentage",
      value: "sgstPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Total Tax Percentage",
      value: "totalTaxPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Discount Amount",
      value: "discountAmount",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Discount Percentage",
      value: "discountPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Attachments",
      value: "attachments",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  const formatDateToInput = (dateString) => {
    if (!dateString) return "";

    if (typeof dateString !== "string") {
      return "";
    }

    const normalizedDate = dateString.trim();
    if (normalizedDate === "-") return "";

    const isoDate = normalizedDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDate) {
      return `${isoDate[1]}-${isoDate[2]}-${isoDate[3]}`;
    }

    const numericDate = normalizedDate.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
    if (numericDate) {
      return `${numericDate[3]}-${numericDate[2]}-${numericDate[1]}`;
    }

    const months = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };

    const parts = normalizedDate.split(" ");
    const dateParts = parts[0].split("-");

    if (dateParts.length === 3) {
      const day = dateParts[0].padStart(2, "0");
      const month = months[dateParts[1]?.toLowerCase()] || dateParts[1];
      const year = dateParts[2];
      return `${year}-${month}-${day}`;
    }

    return dateString;
  };

  const handleEdit = (row) => {
    setHideTestFields(true);
    setIsEdit(true);
    setTyreId(row.id);

    const rawTyreDetails = tyreDetails.find((b) => b.id === row.id);

    let parsedAttachments = [];
    try {
      const attachmentsData = row?.attachments || rawTyreDetails?.attachments;
      if (typeof attachmentsData === "string") {
        parsedAttachments = JSON.parse(attachmentsData);
      } else if (Array.isArray(attachmentsData)) {
        parsedAttachments = attachmentsData;
      }
    } catch (e) {
      parsedAttachments = [];
    }

    setForm({
      tyrePosition: row?.tyrePosition || rawTyreDetails?.tyrePosition || "",
      tyreDotNo: row?.tyreDotNo || rawTyreDetails?.tyreDotNo || "",
      tyreSize: row?.tyreSize || rawTyreDetails?.tyreSize || "",
      tyreType: row?.tyreType || rawTyreDetails?.tyreType || "",
      tyrePrice: row?.tyrePrice || rawTyreDetails?.tyrePrice || "",
      kilometerLimit:
        row?.kilometerLimit || rawTyreDetails?.kilometerLimit || "",
      dateOfManufacturing: formatDateToInput(
        rawTyreDetails?.dateOfManufacturing || row?.dateOfManufacturing || "",
      ),
      manufacuturedBy:
        row?.manufacturedBy || rawTyreDetails?.manufacturedBy || "",
      warrantyPeriod:
        row?.warrantyPeriod || rawTyreDetails?.warrantyPeriod || "",
      purchaseDate: formatDateToInput(
        rawTyreDetails?.purchaseDate || row?.purchaseDate || "",
      ),

      startDate: formatDateToInput(
        rawTyreDetails?.warrantyStartDate || row?.warrantyStartDate || "",
      ),

      endDate: formatDateToInput(
        rawTyreDetails?.warrantyEndDate || row?.warrantyEndDate || "",
      ),

      installedDate: formatDateToInput(
        rawTyreDetails?.installedDate || row?.installedDate || "",
      ),
      isInstalled: row?.isInstalled ? "true" : "false",
      isSwapped: row?.isSwapped ? "true" : "false",
      vehicleNo:
        row?.swappedFromVehicleId ||
        rawTyreDetails?.swappedFromVehicleId ||
        null,
      issueId: row?.issueId || null,
      vendorName: row?.vendorName || rawTyreDetails?.vendorName || null,
      vendorContact:
        row?.vendorContact || rawTyreDetails?.vendorContact || null,
      vendorAddress:
        row?.vendorAddress || rawTyreDetails?.vendorAddress || null,
      attachments: parsedAttachments,
      sgst: row?.sgst || rawTyreDetails?.sgst || null,
      cgst: row?.cgst || rawTyreDetails?.cgst || null,
      totalTax: row?.totalTax || rawTyreDetails?.totalTax || null,
      labourCost: row?.labourCost || rawTyreDetails?.labourCost || null,
      totalCost: row?.totalCost || rawTyreDetails?.totalCost || null,
      sgstPercentage:
        row?.sgstPercentage || rawTyreDetails?.sgstPercentage || null,
      cgstPercentage:
        row?.cgstPercentage || rawTyreDetails?.cgstPercentage || null,
      totalTaxPercentage:
        row?.totalTaxPercentage || rawTyreDetails?.totalTaxPercentage || null,
      discountAmount:
        row?.discountAmount || rawTyreDetails?.discountAmount || null,
      discountPercentage:
        row?.discountPercentage || rawTyreDetails?.discountPercentage || null,
      costToCompany:
        row?.costToCompany || rawTyreDetails?.costToCompany || null,
    });

    // Set uploaded images for preview
    if (row?.attachments) {
      try {
        const attachments =
          typeof row.attachments === "string"
            ? JSON.parse(row.attachments)
            : row.attachments;
        setUploadedImages(attachments);
      } catch (e) {
        setUploadedImages(row?.attachments || null);
      }
    }

    // Scroll to the form section
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const rows =
    (tyreDetails &&
      tyreDetails.map((item) =>
        createData(
          item?.id,
          item?.attachments,
          item?.tyrePosition,
          item?.tyreDotNo,
          item?.tyreSize,
          item?.tyreType,
          item?.tyrePrice,
          item?.kilometerLimit,
          item?.manufacturedBy,
          formatDateAndTime(item?.dateOfManufacturing),
          formatDateAndTime(item?.purchaseDate) || "-",
          item?.isActive,
          item?.warrantyPeriod,
          formatDateAndTime(item?.startDate),
          formatDateAndTime(item?.endDate),
          item?.isInstalled,
          formatDateAndTime(item?.installedDate),
          item?.isSwapped,
          item?.swappedFromVehicleId,
          item?.costToCompany,
          item?.sgstPercentage,
          item?.sgst,
          item?.cgstPercentage,
          item?.cgst,
          item?.totalTaxPercentage,
          item?.totalTax,
          item?.labourCost,
          item?.discountAmount,
          item?.discountPercentage,
          item?.totalCost,
          formatDateAndTime(item?.createdAt),
        ),
      )) ||
    [];

  const grandTotal = rows.reduce((sum, row) => {
    return sum + (Number(row?.totalCost) || 0);
  }, 0);

  const getTyreDetails = async (id, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicletyredetails?serviceLogId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setTyreDetails(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const getVehicleIssues = async (vehicleID, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyIssuesDetails(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const getVehicleAPI = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=${1000}&offset=${0}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setVehicles(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    }
  };

  useEffect(() => {
    if (workOrderDetail) {
      getTyreDetails(
        workOrderDetail.id,
        paginationModel.page,
        paginationModel.pageSize,
      );
      getVehicleIssues(
        workOrderDetail.id,
        paginationModel.page,
        paginationModel.pageSize,
      );
      getVehicleAPI();
    }
  }, [workOrderDetail, paginationModel]);

  const handleChange = async (field, value) => {
    if (field === "attachments") {
      await uploadmutiplefile(value, "vehicles", "vehicle").then((res) => {
        let filterImages = res?.uploaded?.map((image) => image?.url);
        setUploadedImages((prev) => {
          if (!prev || prev.length === 0) {
            return filterImages; // first upload
          }
          return [...prev, ...filterImages]; // append
        });
        setForm((prev) => ({
          ...prev,
          [field]: res?.uploaded || "",
        }));
      });
    } else {
      setForm((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    let newErrors = {};

    // Battery ID
    if (!form.tyrePosition) {
      newErrors.tyrePosition = "Tyre Position is required";
    }

    if (!form.tyreDotNo) {
      newErrors.tyreDotNo = "Tyre DOT no is required";
    }

    if (!form.tyreSize) {
      newErrors.tyreSize = "Tyre Size is required";
    }

    if (!form.tyreType) {
      newErrors.tyreType = "Tyre Type is required";
    }

    if (!form.tyrePrice) {
      newErrors.tyrePrice = "Tyre Price is required";
    }

    if (!form.purchaseDate) {
      newErrors.purchaseDate = "Purchase Date is required";
    }

    // Date of Manufacturing
    if (!form.dateOfManufacturing) {
      newErrors.dateOfManufacturing = "Manufacturing date is required";
    } else if (new Date(form.dateOfManufacturing) > new Date()) {
      newErrors.dateOfManufacturing = "Manufacturing date cannot be future";
    }

    // Manufactured By
    if (!form.manufacuturedBy?.trim()) {
      newErrors.manufacuturedBy = "Manufacturer name is required";
    }

    // Warranty
    if (!form.warrantyPeriod) {
      newErrors.warrantyPeriod = "Warranty period is required";
    } else if (Number(form.warrantyPeriod) <= 0) {
      newErrors.warrantyPeriod = "Warranty must be greater than 0";
    }

    // Start Date
    if (!form.startDate) {
      newErrors.startDate = "Start date is required";
    } else if (
      form.dateOfManufacturing &&
      new Date(form.startDate) < new Date(form.dateOfManufacturing)
    ) {
      newErrors.startDate = "Start date must be after manufacturing date";
    }

    // End Date
    if (!form.endDate) {
      newErrors.endDate = "End date is required";
    } else if (
      form.startDate &&
      new Date(form.endDate) < new Date(form.startDate)
    ) {
      newErrors.endDate = "End date must be after start date";
    }

    // Is Installed
    if (form.isInstalled === undefined) {
      newErrors.isInstalled = "Please select installation status";
    }

    // Installed Date (only if installed)
    if (form.isInstalled === "true" && !form.installedDate) {
      newErrors.installedDate = "Installed date is required";
    }

    // Is Swapped
    if (form.isSwapped === undefined) {
      newErrors.isSwapped = "Please select swap status";
    }

    // if (!form.vendorAddress) {
    //   newErrors.vendorAddress = "Please add Vendor Address";
    // }

    // if (!form.vendorContact) {
    //   newErrors.vendorContact = "Please add Vendor Contact";
    // }

    // if (!form.vendorName) {
    //   newErrors.vendorName = "Please add Vendor Name";
    // }

    // Attachments
    if (!form.attachments || form.attachments.length === 0) {
      newErrors.attachments = "At least one attachment is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddNewBattery = async () => {
    let payload = {};
    if (editTyreId) {
      payload = {
        id: editTyreId,
        tyrePosition: form?.tyrePosition,
        tyreDotNo: form?.tyreDotNo,
        tyreSize: form?.tyreSize,
        tyreType: form?.tyreType,
        tyrePrice: form?.tyrePrice,
        kilometerLimit: form?.kilometerLimit,
        dateOfManufacturing: form?.dateOfManufacturing,
        manufacturedBy: form?.manufacuturedBy,
        purchaseDate: form?.purchaseDate,
        vehicleId: workOrderDetail?.id,
        // isActive: "true",
        warrantyPeriod: form?.warrantyPeriod,
        startDate: form?.startDate,
        endDate: form?.endDate,
        isInstalled: form?.isInstalled === "true" ? 1 : 0,
        installedDate: form?.installedDate,
        isSwapped: form?.isSwapped,
        swappedFromVehicleId: form?.vehicleNo,
        issueId: form?.issueId,
        issueCode: form?.issueId,
        attachments: JSON.stringify(form?.attachments),
        vendorName: form?.vendorName,
        vendorContact: form?.vendorContact,
        vendorAddress: form?.vendorAddress,
        isPaymentPending: form?.isPaymentPending === "true" ? 1 : 0,
        costToCompany: Number(form?.costToCompany),
        serviceLogId: workOrderDetail?.id,
        isArchieved: false,
        sgst: form?.sgst,
        cgst: form?.cgst,
        totalTax: form?.totalTax,
        labourCost: form?.labourCost,
        totalCost: form?.totalCost,
        sgstPercentage: form?.sgstPercentage,
        cgstPercentage: form?.cgstPercentage,
        totalTaxPercentage: form?.totalTaxPercentage,
        discountAmount: form?.discountAmount,
        discountPercentage: form?.discountPercentage,
      };
    } else {
      payload = {
        tyrePosition: form?.tyrePosition,
        tyreDotNo: form?.tyreDotNo,
        tyreSize: form?.tyreSize,
        tyreType: form?.tyreType,
        tyrePrice: form?.tyrePrice,
        kilometerLimit: form?.kilometerLimit,
        manufacturedBy: form?.manufacuturedBy,
        dateOfManufacturing: form?.dateOfManufacturing,
        purchaseDate: form?.purchaseDate,
        vehicleId: workOrderDetail?.id,
        // isActive: "true",
        warrantyPeriod: form?.warrantyPeriod,
        startDate: form?.startDate,
        endDate: form?.endDate,
        isInstalled: form?.isInstalled === "true" ? 1 : 0,
        installedDate: form?.installedDate,
        isSwapped: form?.isSwapped,
        swappedFromVehicleId: form?.vehicleNo,
        issueId: form?.issueId,
        issueCode: form?.issueId,
        attachments: JSON.stringify(form?.attachments),
        vendorName: form?.vendorName,
        vendorContact: form?.vendorContact,
        vendorAddress: form?.vendorAddress,
        isPaymentPending: form?.isPaymentPending === "true" ? 1 : 0,
        costToCompany: Number(form?.costToCompany),
        serviceLogId: workOrderDetail?.id,
        isArchieved: false,
        sgst: form?.sgst,
        cgst: form?.cgst,
        totalTax: form?.totalTax,
        labourCost: form?.labourCost,
        totalCost: form?.totalCost,
        sgstPercentage: form?.sgstPercentage,
        cgstPercentage: form?.cgstPercentage,
        totalTaxPercentage: form?.totalTaxPercentage,
        discountAmount: form?.discountAmount,
        discountPercentage: form?.discountPercentage,
      };
    }
    try {
      const response = await fetch(`${apiUrl}/api/vehicletyredetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({});
        setUploadedImages(null);
        toast.success("New Battery Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setErrors({});
        setTyreId(null);
        setIsEdit(false);
        getTyreDetails(
          workOrderDetail.id,
          paginationModel.page,
          paginationModel.pageSize,
        );
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  return (
    <>
      <div className="flex justify-between p-3 mt-3">
        <h1 className="text-lg font-semibold">Add Tyre Details</h1>{" "}
        {hideTextfields ? (
          <CloseIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(false);
            }}
          />
        ) : (
          <AddCircleOutlineIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(true);
            }}
          />
        )}
      </div>
      {hideTextfields && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 p-3 rounded-lg">
            {generalInformationofTyre.map((field, index) => (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && (
                    <span className="text-red-500 ml-1">*</span>
                  )}
                </label>

                {/* DROPDOWN */}
                {field.type === "dropdown" && (
                  <FormControl fullWidth size="small">
                    <InputLabel id={`select-label-${index}`}>
                      {field.label}
                    </InputLabel>

                    <Select
                      labelId={`select-label-${index}`}
                      value={form[field.value] || ""}
                      label={field.label}
                      disabled={field.disabled}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      sx={{
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4f46e5",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted")
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {/* FILE UPLOAD */}
                {field.type === "file" && (
                  <div className="space-y-2">
                    <Button
                      component="label"
                      variant="outlined"
                      fullWidth
                      disabled={field.disabled}
                      startIcon={<Upload size={18} />}
                      sx={{
                        borderStyle: "dashed",
                        borderRadius: "8px",
                        padding: "12px",
                        color: "#4f46e5",
                        borderColor: "#a5b4fc",
                        "&:hover": {
                          borderColor: "#6366f1",
                          backgroundColor: "#eef2ff",
                        },
                      }}
                    >
                      {form[field.value]?.length
                        ? "Change Files"
                        : "Upload Files"}
                      <input
                        hidden
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                      />
                    </Button>
                  </div>
                )}

                {/* TEXT / NUMBER / DATE */}
                {field.type !== "dropdown" && field.type !== "file" && (
                  <TextField
                    fullWidth
                    size="small"
                    type={field.type}
                    value={form[field.value] || ""}
                    disabled={field.disabled}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                      },
                    }}
                  />
                )}
              </div>
            ))}
          </div>
          {uploadedImages && (
            <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
              {uploadedImages?.length > 0 ? (
                <div className="mt-6 flex gap-4 flex-wrap">
                  {uploadedImages.map((image, index) => (
                    <img
                      key={index}
                      src={
                        image?.url || image?.Location || image?.path || image
                      }
                      alt="Image Preview"
                      className="w-28 h-28 rounded-lg object-cover border shadow"
                    />
                  ))}
                </div>
              ) : (
                <div className="mt-6 flex gap-4 flex-wrap">
                  <img
                    src={uploadedImages}
                    alt="Image Preview"
                    className="w-44 h-44 rounded-lg object-cover border shadow"
                  />
                </div>
              )}
            </div>
          )}
          <div className="flex justify-end p-6">
            {Object.keys(errors).length > 0 && (
              <div className="text-red-600 text-sm mb-4">
                <ul className="list-disc pl-5">
                  {Object.values(errors).map((err, index) => (
                    <li key={index}>{err}</li>
                  ))}
                </ul>
              </div>
            )}

            <button
              onClick={() => {
                if (!validateForm()) return;
                handleAddNewBattery();
              }}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700
  text-white font-semibold px-5 py-2.5 rounded-lg shadow-md"
            >
              {isEdit ? "Update" : "+ Add"}
            </button>
          </div>{" "}
        </>
      )}

      <div className="p-4">
        <TableContainer
          component={Paper}
          sx={{ width: "100%", overflowX: "auto" }}
        >
          {" "}
          <Table sx={{ minWidth: 3500 }}>
            {" "}
            <TableHead>
              {" "}
              <TableRow>
                {" "}
                <TableCell>Id</TableCell> <TableCell>Attachments</TableCell>{" "}
                <TableCell>Tyre Position</TableCell>{" "}
                <TableCell>Tyre Dot No</TableCell>{" "}
                <TableCell>Tyre Size</TableCell>{" "}
                <TableCell>Tyre Type</TableCell>{" "}
                <TableCell>Tyre Price</TableCell>{" "}
                <TableCell>Kilometer Limit</TableCell>{" "}
                <TableCell>Manufacturer Name</TableCell>{" "}
                <TableCell>Date of Manufacturing</TableCell>{" "}
                <TableCell>Purchase Date</TableCell>{" "}
                <TableCell>Is Installed</TableCell>{" "}
                <TableCell>Installed Date</TableCell>{" "}
                <TableCell>Warranty Period</TableCell>{" "}
                <TableCell>Warranty Start</TableCell>{" "}
                <TableCell>Warranty End</TableCell>{" "}
                <TableCell>Is Swapped</TableCell>{" "}
                <TableCell>Swapped From Vehicle</TableCell>{" "}
                <TableCell>Cost to Company</TableCell>{" "}
                <TableCell>SGST %</TableCell> <TableCell>SGST Amount</TableCell>{" "}
                <TableCell>CGST %</TableCell> <TableCell>CGST Amount</TableCell>{" "}
                <TableCell>Total Tax %</TableCell>{" "}
                <TableCell>Total Tax</TableCell>{" "}
                <TableCell>Labour Cost</TableCell>{" "}
                <TableCell>Discount Amount</TableCell>{" "}
                <TableCell>Discount %</TableCell>{" "}
                <TableCell>Total Cost</TableCell>{" "}
                <TableCell>Edit</TableCell>{" "}
              </TableRow>{" "}
            </TableHead>{" "}
            <TableBody>
              {" "}
              {rows.length ? (
                <>
                  {" "}
                  {rows.map((r, index) => (
                    <React.Fragment key={r.id || index}>
                      {" "}
                      <TableRow>
                        {" "}
                        {/* ID */} <TableCell>{r.id ?? "-"}</TableCell>{" "}
                        {/* Attachments */}{" "}
                        <TableCell>
                          {" "}
                          <IconButton
                            size="small"
                            onClick={() => setOpen(open === index ? -1 : index)}
                          >
                            {" "}
                            {open === index ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}{" "}
                          </IconButton>{" "}
                        </TableCell>{" "}
                        {/* Basic Tyre Details */}{" "}
                        <TableCell>
                          {" "}
                          {tyrePosition[r.tyrePosition] || "-"}{" "}
                        </TableCell>{" "}
                        <TableCell>{r.tyreDotNo ?? "-"}</TableCell>{" "}
                        <TableCell>{r.tyreSize ?? "-"}</TableCell>{" "}
                        <TableCell>{r.tyreType ?? "-"}</TableCell>{" "}
                        <TableCell>{r.tyrePrice ?? "-"}</TableCell>{" "}
                        <TableCell>{r.kilometerLimit ?? "-"}</TableCell>{" "}
                        {/* Manufacturer */}{" "}
                        <TableCell>{r.manufacturedBy ?? "-"}</TableCell>{" "}
                        <TableCell> {r.dateOfManufacturing ?? "-"} </TableCell>{" "}
                        {/* Purchase Date */}{" "}
                        <TableCell>{r.purchaseDate ?? "-"}</TableCell>{" "}
                        {/* Installation */}{" "}
                        <TableCell
                          sx={{
                            backgroundColor: r.isInstalled
                              ? "lightgreen"
                              : "lightcoral",
                            color: "black",
                          }}
                        >
                          {" "}
                          {r.isInstalled ? "Yes" : "No"}{" "}
                        </TableCell>{" "}
                        <TableCell>{r.installedDate ?? "-"}</TableCell>{" "}
                        {/* Warranty */}{" "}
                        <TableCell>{r.warrantyPeriod ?? "-"}</TableCell>{" "}
                        <TableCell> {r.warrantyStartDate ?? "-"} </TableCell>{" "}
                        <TableCell> {r.warrantyEndDate ?? "-"} </TableCell>{" "}
                        {/* Swapped */}{" "}
                        <TableCell
                          sx={{
                            backgroundColor: r.isSwapped
                              ? "lightgreen"
                              : "lightcoral",
                            color: "black",
                          }}
                        >
                          {" "}
                          {r.isSwapped ? "Yes" : "No"}{" "}
                        </TableCell>{" "}
                        <TableCell>
                          {" "}
                          {vehicles.filter(
                            (item) => item?.id === r.swappedFromVehicleId,
                          )[0]?.name ?? "-"}{" "}
                        </TableCell>{" "}
                        {/* Cost */}{" "}
                        <TableCell>{r.costToCompany ?? "-"}</TableCell>{" "}
                        {/* SGST */}{" "}
                        <TableCell>{r.sgstPercentage ?? "-"}%</TableCell>{" "}
                        <TableCell>{r.sgst ?? "-"}</TableCell> {/* CGST */}{" "}
                        <TableCell>{r.cgstPercentage ?? "-"}%</TableCell>{" "}
                        <TableCell>{r.cgst ?? "-"}</TableCell> {/* Total Tax */}{" "}
                        <TableCell> {r.totalTaxPercentage ?? "-"}% </TableCell>{" "}
                        <TableCell>{r.totalTax ?? "-"}</TableCell>{" "}
                        {/* Labour Cost */}{" "}
                        <TableCell>{r.labourCost ?? "-"}</TableCell>{" "}
                        {/* Discount */}{" "}
                        <TableCell>{r.discountAmount ?? "-"}</TableCell>{" "}
                        <TableCell>{r.discountPercentage ?? "-"}%</TableCell>{" "}
                        {/* Total Cost */}{" "}
                        <TableCell sx={{ fontWeight: 600 }}>
                          {" "}
                          ₹{" "}
                          {Number(r.totalCost || 0).toLocaleString(
                            "en-IN",
                          )}{" "}
                        </TableCell>{" "}
                        {/* Edit */}{" "}
                        {validation ? null : (
                          <TableCell>
                            {" "}
                            <Button
                              sx={{
                                color: "white",
                                bgcolor: "#1227e6",
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                                "&:hover": { bgcolor: "#0d1eb8" },
                              }}
                              onClick={() => handleEdit(r)}
                            >
                              Edit
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>{" "}
                      {/* Attachments Expanded Row */}{" "}
                      <TableRow>
                        {" "}
                        <TableCell
                          colSpan={30}
                          sx={{
                            p: 0,
                            borderBottom: open === index ? undefined : 0,
                          }}
                        >
                          {" "}
                          <Collapse
                            in={open === index}
                            timeout="auto"
                            unmountOnExit
                          >
                            {" "}
                            <Box sx={{ m: 2 }}>
                              {" "}
                              <Typography
                                variant="h6"
                                sx={{ mb: 2, fontWeight: 700 }}
                              >
                                {" "}
                                Attachments{" "}
                              </Typography>{" "}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 2,
                                }}
                              >
                                {" "}
                                {r.attachments ? (
                                  (() => {
                                    try {
                                      const attachments =
                                        typeof r.attachments === "string"
                                          ? JSON.parse(r.attachments)
                                          : r.attachments;
                                      return Array.isArray(attachments) &&
                                        attachments.length > 0 ? (
                                        attachments.map((file, i) => {
                                          const imageUrl =
                                            file?.url ||
                                            file?.Location ||
                                            file?.image ||
                                            file?.path;
                                          return imageUrl ? (
                                            <Box key={i}>
                                              {" "}
                                              <img
                                                src={imageUrl}
                                                alt={`attachment-${i + 1}`}
                                                onClick={() =>
                                                  handleImageOpen(imageUrl)
                                                }
                                                className="w-44 h-44 cursor-pointer rounded-lg hover:opacity-80 object-cover"
                                              />{" "}
                                            </Box>
                                          ) : null;
                                        })
                                      ) : (
                                        <Typography
                                          sx={{ color: "red" }}
                                          variant="body2"
                                        >
                                          {" "}
                                          No Attachments{" "}
                                        </Typography>
                                      );
                                    } catch (error) {
                                      return (
                                        <Typography
                                          sx={{ color: "red" }}
                                          variant="body2"
                                        >
                                          {" "}
                                          Invalid Attachments{" "}
                                        </Typography>
                                      );
                                    }
                                  })()
                                ) : (
                                  <Typography
                                    sx={{ color: "red" }}
                                    variant="body2"
                                  >
                                    {" "}
                                    No Attachments{" "}
                                  </Typography>
                                )}{" "}
                              </Box>{" "}
                            </Box>{" "}
                          </Collapse>{" "}
                        </TableCell>{" "}
                      </TableRow>{" "}
                    </React.Fragment>
                  ))}{" "}
                  {/* GRAND TOTAL ROW */}{" "}
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    {" "}
                    <TableCell
                      colSpan={28}
                      align="right"
                      sx={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      {" "}
                      Grand Total{" "}
                    </TableCell>{" "}
                    <TableCell sx={{ fontWeight: "bold", fontSize: "16px" }}>
                      {" "}
                      ₹ {grandTotal.toLocaleString("en-IN")}{" "}
                    </TableCell>{" "}
                    {/* Empty cell for Edit column */} <TableCell />{" "}
                  </TableRow>{" "}
                </>
              ) : (
                <TableRow>
                  {" "}
                  <TableCell
                    colSpan={30}
                    align="center"
                    sx={{ fontWeight: "bold", py: 3 }}
                  >
                    {" "}
                    No Tyre Details Found{" "}
                  </TableCell>{" "}
                </TableRow>
              )}{" "}
            </TableBody>{" "}
          </Table>{" "}
        </TableContainer>
      </div>
      {previewOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setPreviewOpen(false)}
        >
          <img
            src={previewImage}
            className="max-h-[90%] max-w-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </>
  );
};

export default Tyresdetails;
